// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
import { NavItem } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { NavLink, useHistory } from 'react-router-dom';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { paths } from '../../infrastructure/constants/NavigationPanel';
import '../../styles/components/NavigationPanel.css';
import MenuToggle from './MenuToggle';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const NavigationPanel = ({ location, visual, logout }) => {
  const history = useHistory();

  const [activePaths, setActivePaths] = useState([]);
  const [isMobileMenuExpanded, setMobileMenuExpanded] = useState(false);

  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const urlPathName = location.pathname;
    const activeIndex = paths.findIndex(path =>
      path.children.some(children => children.path === urlPathName)
    );
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (activeIndex !== -1) setActivePaths([activeIndex]);
  }, []);

  useEffect(
    () =>
      history.listen(() => {
        setMobileMenuExpanded(false);
      }),
    [history]
  );

  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  const isPathActive = index => activePaths.includes(index);

  const onPathClick = (e, index) => {
    let copiedActivePaths = [...activePaths];
    if (isPathActive(index)) {
      copiedActivePaths = copiedActivePaths.filter(item => item !== index);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      copiedActivePaths.push(index);
    }
    setActivePaths(copiedActivePaths);
  };

  const renderIcon = path =>
    path.type === 'icon' ? (
      <span
        className={`${path.icon} nav-icon`}
        style={{ width: '25px', height: '25px' }}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        alt={path.label}
      />
    ) : (
      <img
        className='nav-icon'
        src={path.icon}
        width='25px'
        height='25'
        alt={path.label}
      />
    );

  return (
    <div className='navcont'>
      <img
        src='/bach-logo.png'
        alt='Bach Admin'
        className='logo'
        style={{ marginRight: '15px', display: 'inline' }}
      />
      <MenuToggle
        isExpanded={isMobileMenuExpanded}
        onClick={setMobileMenuExpanded}
      />
      {visual && (
        <div
          className={`sidebar-container ${
            isMobileMenuExpanded ? 'sidebar-container-expanded' : ''
          }`}
        >
          <ul className='nav nav-sidebar nav-parent'>
            {paths.map((path, index) => (
              <li
                key={path.label}
                onClick={e => onPathClick(e, index)}
                className={`${isPathActive(index) ? 'active-link' : ''}`}
              >
                {path.path ? (
                  <NavLink
                    className={`${
                      path.children.length === 0 ? 'no-childs' : ''
                    }`}
                    exact={path.path === '/'}
                    onClick={e => e.stopPropagation()}
                    to={path.path}
                  >
                    <div className='nav-link'>
                      {renderIcon(path)}
                      <p className='nav-label'>{path.label}</p>
                    </div>
                  </NavLink>
                ) : (
                  <a>
                    <div className='nav-link'>
                      {renderIcon(path)}
                      <p className='nav-label'>{path.label}</p>
                    </div>
                  </a>
                )}
                {path.children && path.children.length > 0 && (
                  <ul className='nav nav-sidebar nav-children'>
                    {path.children.map(child => (
                      <li key={path.label + child.label}>
                        {child.external ? (
                          <a href={child.path}>{child.label}</a>
                        ) : (
                          <NavLink
                            exact={child.path === '/'}
                            onClick={e => e.stopPropagation()}
                            to={child.path}
                          >
                            {child.label}
                          </NavLink>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          <ul className='bottom-nav nav nav-sidebar'>
            <NavItem onClick={logout}>
              <div className='nav-link'>
                <span
                  className='fas fa-sign-out-alt nav-icon'
                  style={{ width: '25px', height: '25px' }}
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  alt='logout'
                />
                <p className='nav-label'>Logout</p>
              </div>
            </NavItem>
          </ul>
        </div>
      )}
    </div>
  );
};

export default React.memo(NavigationPanel);
